import { render, staticRenderFns } from "./VehicleTariffsForm.vue?vue&type=template&id=e36d4162&"
import script from "./VehicleTariffsForm.vue?vue&type=script&lang=js&"
export * from "./VehicleTariffsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e36d4162')) {
      api.createRecord('e36d4162', component.options)
    } else {
      api.reload('e36d4162', component.options)
    }
    module.hot.accept("./VehicleTariffsForm.vue?vue&type=template&id=e36d4162&", function () {
      api.rerender('e36d4162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Vehicles/Forms/VehicleTariffsForm.vue"
export default component.exports